'use strict';

var ElementSpecificMessage = require('./ElementSpecificMessage');
var CheckableItemsList = require('./CheckableItemsList');
var BootstrapAccordion = require('./BootstrapAccordion');

var WebRemoting = require('../WebRemoting');
WebRemoting.require('ColumnSelectorService');
WebRemoting.require('MrColumnSelectorService');

var ColumnSelector = function(container, options) {
    this.initialize(container, options);
};

ColumnSelector.prototype = {
    /**
     * Contains messages displayed to the user which need to be set
     * by the JSP at request-time with internationalized values.
     */
    _messages: {
        loading: null
    },

    _maxSearchResults: 500,

    /**
     * Configuration Options for widget
     */
    _container: null,
    _sourceId: null, // the source to get columns for, either a MD cube or a MR report source.
    _isMrSource: false, // indicates if the 'sourceId' is a MITS Report source
    _multiselect: false,
    _drillDownPathDimensionAbbreviations: null,
    _currentColumnIds: null,
    _includeCalculatedColumns: false,
    _includeExternalColumns: true,
    _selectedOrderableItemListWidget: null,
    _clickListener: null,
    _$searchInput: null,
    _searchButton: null,
    _initiallySelectedColumns: [],

    /**
     * Other internal fields
     */
    _resultsLoadingMessage: null,
    _formBackingData: null, //just for reference/debugging
    _rootWidgetNodeDiv: null,
    _rootWidgetNode: null, //contains all the widgets
    _currentlyDisplayedList: null,
    _columns: null, //used to search against, generated from _formBackingData
    _$searchCheckableItemsListDiv: null,
    _searchCheckableItemsList: null,

    /* eslint-disable complexity */
    initialize: function(container, options){
        this._container = typeof container === 'string' ? document.getElementById(container) : container;
        var messageCssClass = 'busyMessage';
        var initialSelections = null;

        if (options) {
            if (options.selectedOrderableItemListWidget) {
                this._selectedOrderableItemListWidget = options.selectedOrderableItemListWidget;
            }

            if (options.messages) {
                this._messages = options.messages;
            }

            if (options.clickListener) {
                this._clickListener = options.clickListener;
            }

            if (options.multiselect) {
                this._multiselect = options.multiselect;
            }else{
                this._multiselect = false; //default
            }

            if (options.drillDownPathDimensionAbbreviations) {
                this._drillDownPathDimensionAbbreviations = options.drillDownPathDimensionAbbreviations;
            }

            if (options.currentColumnIds) {
                this._currentColumnIds = options.currentColumnIds;
            }

            //Note: this assumes a default of false because we will not go into the if-statement if trying to set it to false
            if (options.includeCalculatedColumns) {
                this._includeCalculatedColumns = options.includeCalculatedColumns;
            }

            if (options.includeExternalColumns !== undefined) {
                this._includeExternalColumns = options.includeExternalColumns;
            }

            if (options.initialSelections) {
                initialSelections = options.initialSelections;
                this._initiallySelectedColumns = options.initialSelections;
            }

            if (options.messageCssClass) {
                messageCssClass = options.messageCssClass;
            }

            if (options.sourceId) {
                this._sourceId = options.sourceId;
            }

            if(options.isMrSource){
                this._isMrSource = options.isMrSource;
            }

            if (options.searchInput) {
                if (typeof options.searchInput === 'string') {
                    this._$searchInput = jQuery('#' + options.searchInput);
                } else {
                    this._$searchInput = jQuery(options.searchInput);
                }
            }

            if (options.searchButton) {
                this._searchButton = options.searchButton;
            }
        }

        // Global variables have to be initialized after the messages are set.
        // The JSP sets the messages as the page is loading.
        this._resultsLoadingMessage = new ElementSpecificMessage(this._container, this._messages.loading, {messageCssClass: messageCssClass});

        //create a child div to hold the tree of accordions
        this._rootWidgetNodeDiv = document.createElement('div');
        this._container.appendChild(this._rootWidgetNodeDiv);

        //register uncheck listener
        //HACK: Note: this will overwrite any existing removeListener on the OrderableItemWidget
        if(this._selectedOrderableItemListWidget) {
            this._selectedOrderableItemListWidget._removeListener = this.uncheckColumn.bind(this);
        }

        this._populate();

        // This can be called any time after the page is loaded
        if(initialSelections && this._selectedOrderableItemListWidget){
            for (var i=0; i<initialSelections.length; i++) {
                this._selectedOrderableItemListWidget.addItem(initialSelections[i].id, initialSelections[i].description);
            }
        }

        this._initializeSearch();
    },
    /* eslint-enable complexity */

    _debounce: function(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        }; 
    },
    
    _initializeSearch: function(){
        //setup search functionality
        if(this._$searchInput){
            this._$searchCheckableItemsListDiv = jQuery('<div></div>');
            this._$searchCheckableItemsListDiv.hide();
            this._$searchCheckableItemsListDiv.appendTo(this._container);
            this._$searchInput.on('input', this._debounce(this._searchListener.bind(this), 250, true));

            if(this._searchButton){
                jQuery(this._searchButton).on('click', this._searchListener.bind(this));
            }
        }
    },

    _populate: function(){
        var msg = this._resultsLoadingMessage;
        // This is to get around an order of operations problem. For _resultsLoadingMessage to size and position itself
        // correctly, its parent must be visible on the screen. However, if this ColumnSelector is on a dialog, it'll be
        // hidden by the .loading class until after it's initialized and rendered. So throwing the show() onto a timeout
        // to move that call to after the selector's been rendered
        setTimeout(function () {
            msg.show();
        }, 10);

        var options = WebRemoting.createRemoteCallOptions(
                this._displayFormBackingData.bind(this),
                this._fetchFormBackingDataFailureCallback.bind(this));
        if(this._isMrSource){
            // get MITS Report columns.  This is separate in the hopes that it won't be too hard to merge to hoverboard
            MrColumnSelectorService.getFormBackingData(this._sourceId, options);
        } else {
            var selectedColumns = {};
            for (var i=0; i<this._initiallySelectedColumns.length; i++){
                selectedColumns[this._initiallySelectedColumns[i].id] = this._initiallySelectedColumns[i].description;
            }
            ColumnSelectorService.getFormBackingData(this._sourceId, this._drillDownPathDimensionAbbreviations, this._currentColumnIds, selectedColumns, this._includeCalculatedColumns, this._includeExternalColumns, options);
        }
    },

    _displayFormBackingData: function(columnSelectionData) {
        //Make sure the widget is still on the page.  Example: The user could have closed a modal.
        if(!this._container || !document.getElementById(this._container.id)){
            this._resultsLoadingMessage.hide();
            return;
        }

        var formBackingData = columnSelectionData.data;

        this._formBackingData = formBackingData;
        this._rootWidgetNode = new ColumnSelector.WidgetNode(this._rootWidgetNodeDiv, {formBackingData: formBackingData, parentColumnSelector: this}); //this builds the UI
        this._resultsLoadingMessage.hide();

        //Auto-expand to the first selected column
        if(this._selectedOrderableItemListWidget){
            var checkedColumnIds = this._selectedOrderableItemListWidget.getOrderedIds();

            if(checkedColumnIds && checkedColumnIds.length>0){
                var firstSelectedColumnId = checkedColumnIds[0];
                if(firstSelectedColumnId){
                    this.expandToColumn(firstSelectedColumnId);
                }
            }
        }

        this._columns = this._createColumnsList(this._formBackingData);

        //do a search if the user typed in the search box while we were fetching the list of columns
        if(this._$searchInput){
            this.search(this._$searchInput.val());
        }
    },

    _fetchFormBackingDataFailureCallback: function() {
        this._resultsLoadingMessage.hide();
    },

    _createColumnsList: function(formBackingData){
        var columnIdToColumnMap = []; //map of id to column

        //use a map to ensure we do not get duplicate columns in the list
        this._addColumnToMap(columnIdToColumnMap, formBackingData);

        var columnsList = [];

        for(var columnId in columnIdToColumnMap){
            var column = columnIdToColumnMap[columnId];
            columnsList.push(column);
        }

        //Note: Do not need to sort the list, because the search will sort them by relevance

        return columnsList;
    },

    _addColumnToMap: function(columnIdToColumnMap, formBackingData){
        if(this._isFormBackingDataCheckableItemsList(formBackingData)){
            for(var i=0;i<formBackingData.length;i++){
                var column = formBackingData[i];
                columnIdToColumnMap[column.id] = column;
            }
        }else{
            for(var key in formBackingData){
                var nestedFormBackingData = formBackingData[key];
                this._addColumnToMap(columnIdToColumnMap, nestedFormBackingData);
            }
        }
    },

    checkColumn: function(columnId) {
        if (this._currentlyDisplayedList) {
            this._currentlyDisplayedList.checkItem(columnId);
        }
        if (this._searchCheckableItemsList) {
            this._searchCheckableItemsList.checkItem(columnId);
        }
    },

    uncheckColumn: function(columnId) {
        if (this._currentlyDisplayedList) {
            this._currentlyDisplayedList.uncheckItem(columnId);
        }
        if (this._searchCheckableItemsList) {
            this._searchCheckableItemsList.uncheckItem(columnId);
        }
    },

    uncheckAllColumns: function() {
        if (this._currentlyDisplayedList) {
            this._currentlyDisplayedList.uncheckAllItems();
        }
        if (this._searchCheckableItemsList) {
            this._searchCheckableItemsList.uncheckAllItems();
        }
    },

    hideLoadingMessage: function(){
        this._resultsLoadingMessage.hide();
    },

    /**
     * Expands to the first instance of columnId in the tree
     */
    expandToColumn: function(columnId) {
        if(this._rootWidgetNode){
            this._rootWidgetNode.expandToColumn(columnId);
        }
    },

    _searchListener: function(){
        this.search(this._$searchInput.val());
        return false;
    },

    /* eslint-disable complexity */
    search: function(searchInputText){
        if(!this._columns){
            //we have not gotten the list of columns yet so do not search
            return;
        }

        //if they are searching replace the current tree of columns with the search results,
        // otherwise just display the normal tree of columns.
        if(searchInputText && searchInputText.length>0){
            if(this._rootWidgetNodeDiv){
                jQuery(this._rootWidgetNodeDiv).hide();
            }

            if(this._$searchCheckableItemsListDiv){
                this._$searchCheckableItemsListDiv.show();
            }

            this._container.scrollTop = 0;

            //search on each word individually, each word is ANDed
            var result = this._columns;
            var quotedWords = searchInputText.split('"');

            var inputWords = new Array();
            for (var quotedWordIndex = 0; quotedWordIndex < quotedWords.length; quotedWordIndex++) {
                if (quotedWordIndex % 2 === 0) {
                    //outside quotes
                    var spaceDelimitedWords = quotedWords[quotedWordIndex].split(/\s+/);
                    for (var spaceWordIndex = 0; spaceWordIndex < spaceDelimitedWords.length; spaceWordIndex++) {
                        inputWords.push(spaceDelimitedWords[spaceWordIndex]);
                    }
                } else {
                    //inside quotes
                    inputWords.push(quotedWords[quotedWordIndex]);
                }
            }
            
            for(var wordIndex=0;wordIndex<inputWords.length;wordIndex++){
                var word = inputWords[wordIndex];

                //only search on non-whitespace
                if(word && word.length>0){
                    word = word.toLowerCase();
                    var newResult = new Array();
                    for (var resultIndex = 0; resultIndex < result.length; resultIndex++) {
                        var element = result[resultIndex];
                        if (element && element.description && element.description.toLowerCase().indexOf(word) > -1) {
                            newResult.push(element);
                        }
                    }
                    result = newResult;
                }
            }

            if(result && result.length>0){
                this._searchCheckableItemsList = this._createCheckableItemsList(this._$searchCheckableItemsListDiv[0], result, this._maxSearchResults);

            }else{
                this._$searchCheckableItemsListDiv.empty();
            }

        }else{
            if(this._$searchCheckableItemsListDiv){
                this._$searchCheckableItemsListDiv.hide();
            }

            if(this._rootWidgetNodeDiv){
                jQuery(this._rootWidgetNodeDiv).show();
            }
        }
    },
    /* eslint-enable complexity */

    _createCheckableItemsList: function(containerDiv, columns, maxItems){
        var checkableItemsOptions = {
            allowRangeSelection: this._multiselect,
            useRadioButtons: !this._multiselect,
            clickListener: this._checkableItemsListClickListener.bind(this)
        };

        var widget = new CheckableItemsList(containerDiv, checkableItemsOptions);

        for(var i=0;i<columns.length && i < maxItems;i++){
            var columnInfo = columns[i];
            var id = columns[i].id;
            var isChecked = this._isItemSelected(id);
            widget.addItem(columnInfo.id, columnInfo.description, isChecked);
        }

        if (columns.length > maxItems) {
            widget.addAdditionalItemsNotice('Only the first ' + maxItems + ' results shown. Please use search options to find specific results');
        }

        return widget;
    },

    // Gets called when a checkbox is clicked. It updates the selected columns list.
    _checkableItemsListClickListener: function(columnId, description, isChecked) {
        if(!this._doClickListener(columnId, description, isChecked)){
            return false;
        }

        if(this._multiselect){
            if (isChecked) {
                this._addSelectedItem(columnId, description);
            }
            else {
                this._removeSelectedItem(columnId);
            }
        }else{
            this._removeAllItems();
            this._addSelectedItem(columnId, description);
        }
    },

    _doClickListener: function(columnId, description, isChecked){
        //If this is the root node then it should have a _clickListener to execute,
        if(this._clickListener){
            if(!this._clickListener(columnId, description, isChecked)){
                return false;
            }
        }

        return true;
    },

    /*
        Internal Methods for making sure the widget that holds the selections is notified about updates.
     */
    _addSelectedItem: function(columnId, description){
        if(this._selectedOrderableItemListWidget) {
            return this._selectedOrderableItemListWidget.addItem(columnId, description);
        }
    },

    _removeSelectedItem: function(columnId){
        if(this._selectedOrderableItemListWidget) {
            return this._selectedOrderableItemListWidget.removeItem(columnId);
        }
    },

    _removeAllItems: function(){
        if(this._selectedOrderableItemListWidget) {
            return this._selectedOrderableItemListWidget.removeAllItems();
        }
    },

    _isItemSelected: function(columnId){
        if(this._selectedOrderableItemListWidget) {
            return this._selectedOrderableItemListWidget.containsItem(columnId);
        }
    },


    /*
        Helper Methods
     */
    _isFormBackingDataCheckableItemsList: function(formBackingData){
        return (formBackingData.constructor === Array);
    }
};

ColumnSelector.WidgetNode = function(container, options) {
    this.initialize(container, options);
};

ColumnSelector.WidgetNode.prototype = {
    /**
     * Provides a
     * by the JSP at request-time with internationalized values.
     */
    _container: null,

    _parentColumnSelector: null, //for fetching configuration information that pertains to the whole tree of nodes

    _formBackingData: null, //form backing data for this node and descendants

    _accordion: null,

    _childWidgetNodes: null,
    _childAccordionNames: null,

    initialize: function(container, options){
        this._container = typeof container === 'string' ? document.getElementById(container) : container;

        if (options) {
            //_parentColumnSelector must be set before anything else, because the rest of the code requires
            // _parentColumnSelector to be set so it can access configuration information.
            if(options.parentColumnSelector) {
                this._parentColumnSelector = options.parentColumnSelector;
            }

            //When we receive "formBackingData" as an option we construct the WidgetNode tree.
            if (options.formBackingData) {
                var nodeLevel = 0;

                if(options.nodeLevel){
                    nodeLevel = options.nodeLevel;
                }

                this._formBackingData = options.formBackingData;
                this._initializeNodeFromFormBackingData(this._container, this._formBackingData, nodeLevel);
            }
        }
    },

    /**
     * Expands to the first instance of columnId in the tree.
     *
     * @return boolean true if the column was found to expand
     */
    expandToColumn: function(columnId, isRecursiveCall) {
        if (this._isFormBackingDataCheckableItemsList(this._formBackingData)) {
            for (var i = 0; i < this._formBackingData.length; i++) {
                var formBackingColumn = this._formBackingData[i];

                if (formBackingColumn.id === columnId) {
                    return true;
                }
            }
        } else {
            for (var j=0;j<this._childAccordionNames.length;j++) {
                //which accordion does this go with???
                var groupName = this._childAccordionNames[j];
                var nestedWidgetNode = this._childWidgetNodes[j];

                var nestedFormBackingData = this._formBackingData[groupName];
                if (nestedFormBackingData) {
                    if (nestedWidgetNode.expandToColumn(columnId, true)) {
                        this._expandAccordionWidget(groupName, isRecursiveCall);
                        if(this._accordion) {
                            this._accordion.expand(groupName);
                        }
                        return true;
                    }
                }
            }
        }

        return false;
    },

    _initializeNodeFromFormBackingData: function(containerDiv, formBackingData, nodeLevel){
        if(this._isFormBackingDataCheckableItemsList(formBackingData)){
            //the list of selectable columns, do not create it here.  It gets created when that widget is expanded.

        }else{
            //Nested Group
            this._initializeAccordionWidget(containerDiv, formBackingData, nodeLevel);
        }
    },

    _initializeAccordionWidget: function(containerDiv, formBackingData, nodeLevel){
        //only indent if this is not the first div
        containerDiv.style.marginLeft = (nodeLevel === 0 ? '0px' : '24px');

        var headings = [];
        var headingContents = [];

        var accordionOptions = {showExpandCollapseIcon: true,
            expandListener: this._expandAccordionWidget.bind(this),
            collapseCompleteListener: this._collapseAccordionWidget.bind(this),
            scrollContainer: this._parentColumnSelector._container
        };

        this._accordion = new BootstrapAccordion(containerDiv, accordionOptions);
        this._childWidgetNodes = [];
        this._childAccordionNames = [];

        for(var key in formBackingData) {
            headings.push(key.htmlDecode()); // encode keys for html here

            var nestedFormBackingData = formBackingData[key];

            var widgetNodeOptions = {
                parentColumnSelector: this._parentColumnSelector,
                formBackingData: nestedFormBackingData,
                nodeLevel: nodeLevel+1
            };


            var nestedDiv = document.createElement('div');
            this._container.appendChild(nestedDiv);

            var childWidgetNode = new ColumnSelector.WidgetNode(nestedDiv, widgetNodeOptions);

            headingContents.push(nestedDiv);
            this._childWidgetNodes.push(childWidgetNode);
            this._childAccordionNames.push(key);
        }

        this._accordion.setHeadings(headings, headingContents);
    },

    _expandAccordionWidget: function(groupName){
        if(this._accordion){
            var nestedFormBackingData = this._formBackingData[groupName];

            if(nestedFormBackingData){
                if(this._isFormBackingDataCheckableItemsList(nestedFormBackingData)){
                    var nestedDiv = document.createElement('div');
                    this._container.appendChild(nestedDiv);

                    var nestedCheckableItemsList = this._parentColumnSelector._createCheckableItemsList(nestedDiv, nestedFormBackingData, Number.MAX_VALUE);
                    this._parentColumnSelector._currentlyDisplayedList = nestedCheckableItemsList;

                    this._accordion.setHeadingContent(groupName, nestedDiv);
                }
            }
        }
    },

    /**
     * When the user collapses a group, we remove the column table from
     * the DOM to prevent the DOM from growing to large and slowing down
     * the java script.
     *
     * Also closes all children.
     */
    _collapseAccordionWidget: function(groupName, e) {
        if (this._accordion) {
            if (groupName) {
                var nestedFormBackingData = this._formBackingData[groupName];

                if (nestedFormBackingData) {
                    if (this._isFormBackingDataCheckableItemsList(nestedFormBackingData)) {
                        this._accordion.setHeadingContent(groupName, document.createTextNode(''));
                    }
                }
            } else {
                this._collapseAll();
            }
        }

        //The click event to collapse the node will bubble up the parent nodes, but we don't want those to close. So only
        //collapsing all children if this is the node clicked
        if (e.currentTarget === e.target) {
            this._collapseAllChildren();
        }
    },

    _collapseAllChildren: function() {
        //make sure children are collapsed too
        if (this._childWidgetNodes) {
            for(var i=0;i<this._childWidgetNodes.length;i++){
                var childWidgetNode = this._childWidgetNodes[i];
                childWidgetNode._collapseAll();
            }
        }
    },

    _collapseAll: function() {
        if (this._accordion) {
            this._accordion.collapseAll();
        }
        this._collapseAllChildren();
    },

    _isFormBackingDataCheckableItemsList: function(formBackingData){
        return this._parentColumnSelector._isFormBackingDataCheckableItemsList(formBackingData);
    }
};

module.exports = ColumnSelector;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/ColumnSelector.js
// module id = 31
// module chunks = 0